import classNames from 'classnames';
import React, { useContext } from 'react';
import { PageStateContext } from '@components/Providers/PageStateProvider';
import Video from '@components/Video';
import { Referents } from '@components/Referents/index';
import { useTranslation } from 'react-i18next';
import { JOB_PAGE_STATES } from '@model/Job/_constants/Job.constants';
import { useStoreState } from 'easy-peasy';
import { selectorJobIsReverseMarketing } from '@model/Job/Job.selectors';

export const InterviewingSidebar = () => {
  const { t } = useTranslation();
  const pageState = useContext(PageStateContext);
  const isJobReverseMarketing = useStoreState(selectorJobIsReverseMarketing);

  const isPageStateDoing = pageState === JOB_PAGE_STATES.DOING;

  const wrapperClassNames = classNames('rev-u-px-16 rev-o-col-12', {
    'rev-o-col--medium-6': !isPageStateDoing,
    'rev-o-col--medium-3 u-hidden-medium-down': isPageStateDoing,
  });

  const isReferentSectionVisible =
    pageState === JOB_PAGE_STATES.DONE && !isJobReverseMarketing;

  const isChatImageVisible = isPageStateDoing && !isJobReverseMarketing;

  const chatImageSrc = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/aaron-king/chat.png`
    : `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/chat.png`;

  return (
    <div className={wrapperClassNames}>
      {pageState === JOB_PAGE_STATES.TO_DO ? (
        <div className="o-sidebar">
          <Video video="laptop" sources={['webm']} />
        </div>
      ) : null}

      {isChatImageVisible && (
        <img
          data-testid="interviewing-page-img"
          className="rev-u-mt-32"
          width="256"
          src={chatImageSrc}
          alt={t('interviewing.header.title')}
        />
      )}

      {isReferentSectionVisible && <Referents />}
    </div>
  );
};
